import AppPopUp from 'features/common/AppPopUp';
import { Col, FlexCol, Label, MainButton, centered } from 'features/common/Styles';
import { memo, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { deleteFolder } from 'redux/folder';
import styled from 'styled-components';
import { HomeContext } from 'utils/contexts/HomeContext';
import { useEnterKeydown, useEscapeKeydown } from 'utils/hooks/useKeydown';

export const DeleteFolderModal = memo(() => {
  const { t } = useTranslation('home');
  const dispatch = useDispatch();

  const { selectedFolderId, modalType, setSelectedFolderId, setModalType } = useContext(HomeContext);

  // @effects

  useEscapeKeydown(() => {
    if (modalType === 'deleteFolder') setModalType(null);
  }, [modalType]);

  useEnterKeydown(() => {
    if (modalType === 'deleteFolder') handleDeleteClick();
  }, [selectedFolderId, modalType]);

  // @handlers

  const handleDeleteClick = useCallback(() => {
    if (selectedFolderId) dispatch(deleteFolder(selectedFolderId));
    setSelectedFolderId(null);
    setModalType(null);
  }, [selectedFolderId, modalType, deleteFolder]);

  // @render

  return (
    <AppPopUp open={modalType === 'deleteFolder'} onClose={() => setModalType(null)}>
      <Container style={centered}>
        <FlexCol style={{ ...centered, borderRadius: 8 }}>
          <Title style={{ fontSize: 40, marginBottom: 20, marginTop: 28 }}>{'📄'}</Title>
          <Title>{t('deleteFolderTitle')} </Title>
          <InformationText>{t('deleteFolderInfo')}</InformationText>
        </FlexCol>

        <BottomContainer>
          <MainButton text={t('delete')} onClick={handleDeleteClick} />
        </BottomContainer>
      </Container>
    </AppPopUp>
  );
});

const Container = styled(Col)`
  width: 420px;
  height: 248px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px 20px 0px 20px;
  background-color: ${(props) => props.theme.colors.white};
`;

const BottomContainer = styled.div`
  width: 100%;
  padding: 20px;
`;

const Title = styled(Label)`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 10px;
  text-align: center;
`;

const InformationText = styled(Label)`
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
`;
